import * as React from "react";
import { connect } from "react-redux";
import { Theme, createStyles } from '@mui/material/styles';;
import { withStyles, WithStyles } from '@mui/styles';;
import idssStyle from "../../../Configuration/SharedStyling";
import {
    IGenericUserProps,
    genericMapStateToProps
} from "../../../DataClasses/GenericUser";
import { Redirect } from "react-router-dom";
import { AjaxError } from "rxjs/ajax";
import { firstValueFrom } from "rxjs";
import ReportsService from "../../Services/ReportsService";
import { ISubmissionCountOnMeasureReportData } from "../../../DataClasses/SubmissionData";
import { Grid2 as Grid, Typography } from '@mui/material';
import BackNavigation from '../../Shared/BackNavigation';
import SharedMaterialReactTable, { ISharedTableColumn } from "../../Shared/MaterialReactTable";

const styles = (theme: Theme) => createStyles({ ...idssStyle(theme) });

interface ISubmissionCountOnMeasureReportState {
    isLoading: boolean;
    data: any[],
    redirect: boolean
}

type IStylesProps = WithStyles<typeof styles>;

class SubmissionCountOnMeasureReportView extends React.Component<
    IGenericUserProps & IStylesProps,
    ISubmissionCountOnMeasureReportState
> {
    constructor(props: any) {
        super(props);
        this.state = {
            isLoading: true,
            data: [],
            redirect: false
        };
    }

    public componentDidMount() {
        this.RefreshModel();
    }

    private getTableColumns = (): ISharedTableColumn<any>[] => [
        {
            accessorKey: 'measureCode',
            header: 'Measure',
            enableSorting: true,
            enableFiltering: true,
        },
        {
            accessorKey: 'productLine',
            header: 'Product Line',
            enableSorting: true,
            enableFiltering: true,
        },
        {
            accessorKey: 'submissionCount',
            header: 'Submission Count',
            enableSorting: true,
            enableFiltering: true,
        },
    ];

    public render() {
        if (this.state.redirect) {
            return this.redirectToErrorPage();
        }
        const { classes } = this.props;
        return (
            <div>
                <Grid container={true} className={classes.gridRowFlex} spacing={0}>
                    <Grid size={12}>
                        <Grid container={true} spacing={2}>
                            <Grid size={12}>
                                <BackNavigation text="Back to Reports" href="/reportspage" />
                            </Grid>
                        </Grid>
                    </Grid>
                    <Grid size="auto">
                        <Typography className={`${classes.HighlightedNoteSmall}`}> * Note: Submissions with Plan Locked or later and Measures (or indicator level) with any Aduit Designation R (Reported) or NA (Small Denominator) are counted.</Typography>
                        <div className={classes.card}>
                            <SharedMaterialReactTable
                                data={this.state.data}
                                columns={this.getTableColumns()}
                                title="Submission Count on Measure Report (HEDIS Only)"
                                isLoading={this.state.isLoading}
                                enablePagination={true}
                                enableSorting={true}
                                enableFiltering={true}
                                enableColumnActions={true}
                                enableRowActions={false}
                                initialState={{
                                    pagination: { pageIndex: 0, pageSize: 15 },
                                }}
                                muiPaginationProps={{
                                    rowsPerPageOptions: [15, 20, 25, 50, 75, 100, 500, 1000],
                                }}
                                emptyMessage="No submission count data found."
                            />
                        </div>
                    </Grid>
                </Grid>
            </div>)
    }

    private async RefreshModel() {
        this.setState({ isLoading: true });
        const retval: ISubmissionCountOnMeasureReportData[] | AjaxError =
            await firstValueFrom(
                ReportsService.GetSubmissionCountOnMeasureReportData$(this.props.user)
            );
        if (retval instanceof AjaxError || !retval) {
            this.setRedirectState();
        } else {
            this.setState({
                data: retval.map(x => ({
                    measureCode: x.measureCode,
                    productLine: x.productLine,
                    submissionCount: x.submissionCount
                }))
            });
        }
        this.setState({ isLoading: false });
    }

    private setRedirectState() {
        this.setState({ redirect: true });
    }
    private redirectToErrorPage() {
        return <Redirect to='/errorpage' />;
    }
}

// REDUX CONTAINER
const SubmissionCountOnMeasureReportPageWithState = connect<IGenericUserProps>(
    genericMapStateToProps
)(SubmissionCountOnMeasureReportView);

// STYLES CONTAINER
const SubmissionCountOnMeasureReport = withStyles(styles)(
    SubmissionCountOnMeasureReportPageWithState
);

export default SubmissionCountOnMeasureReport;
